import { render, staticRenderFns } from "./crownDropdowns.vue?vue&type=template&id=3b3ce003&scoped=true&"
import script from "./crownDropdowns.vue?vue&type=script&lang=js&"
export * from "./crownDropdowns.vue?vue&type=script&lang=js&"
import style0 from "./crownDropdowns.vue?vue&type=style&index=0&id=3b3ce003&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ce003",
  null
  
)

export default component.exports